import React from 'react';
import styled from 'styled-components';
import { usePWA } from '../../hooks/usePWA';

const PWAUpdateNotification: React.FC = () => {
  const { hasUpdate, reloadApp } = usePWA();

  if (!hasUpdate) {
    return null;
  }

  return (
    <UpdateNotificationContainer>
      <UpdateContent>
        <UpdateIcon>🔄</UpdateIcon>
        <UpdateText>
          <UpdateTitle>Update Available</UpdateTitle>
          <UpdateDescription>
            A new version of the app is available. Reload to get the latest features.
          </UpdateDescription>
        </UpdateText>
        <UpdateActions>
          <UpdateButton onClick={reloadApp}>
            Update Now
          </UpdateButton>
        </UpdateActions>
      </UpdateContent>
    </UpdateNotificationContainer>
  );
};

const UpdateNotificationContainer = styled.div`
  position: fixed;
  top: 20px;
  left: 20px;
  right: 20px;
  background: ${({ theme }) => theme.colors.interactive.primary};
  color: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  z-index: 1001;
  animation: slideDown 0.3s ease-out;

  @media (min-width: 768px) {
    left: auto;
    right: 20px;
    max-width: 400px;
  }

  @keyframes slideDown {
    from {
      transform: translateY(-100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const UpdateContent = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 12px;
`;

const UpdateIcon = styled.div`
  font-size: 24px;
  flex-shrink: 0;
`;

const UpdateText = styled.div`
  flex: 1;
  min-width: 0;
`;

const UpdateTitle = styled.h3`
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: white;
`;

const UpdateDescription = styled.p`
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.4;
`;

const UpdateActions = styled.div`
  flex-shrink: 0;
`;

const UpdateButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  &:focus {
    outline: 2px solid white;
    outline-offset: 2px;
  }
`;

export default PWAUpdateNotification;